module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2x"
  }, [_c('a', {
    attrs: {
      "id": "page_xix"
    }
  }), _c('a', {
    attrs: {
      "id": "abb"
    }
  }), _vm._v("LIST OF ABBREVIATIONS")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The following is a list of archival collections consulted during research on this book and the abbreviations adopted when referencing them in bibliographic citations:")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("ST. PETERSBURG")])]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "width": "20%"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablet"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("TSGIA SPB")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablet"
  }, [_vm._v("Tsentral’nyi gosudarstvennyi istoricheskii arkhiv Sankt-Peterburga (Central State Historical Archive, St. Petersburg).")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("KR RIII")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_vm._v("Kabinet rukopisei Rossiiskogo instituta istorii iskusstv (Manuscript Office of the Russian Institute for the History of the Arts).")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("OR RNB")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_vm._v("Otdel rukopisei Rossiiskoi natsional’noi biblioteki (Manuscript Division of the Russian National Library).")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("OR SPBGK")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_vm._v("Otdel rukopisei i arkhiv Sankt-Peterburgskoi gosudarstvennoi konservatorii imeni N. A. Rimskogo-Korsakova (Manuscript Division and Archive of the N. A. Rimsky-Korsakov St. Petersburg State Conservatory).")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("Muzykal’naia biblioteka Sankt-Peterburgskoi akademicheskoi filarmonii imeni D. D. Shostakovicha (The Music Library of the St. Petersburg D. D. Shostakovich Academic Philharmonic).")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_c('a', {
    attrs: {
      "id": "page_xx"
    }
  }), _vm._v("Fonogramarkhiv Instituta russkoi literatury (Pushkinskii dom) Rossiiskoi akademii nauk (Phonogram Archive of the Institute of Russian Literature [Pushkin House] of the Russian Academy of Sciences).")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("Tsentral’nyi gosudarstvennyi arkhiv kinofotofonodokumentov Sankt-Peterburga (Central State Archive of Film, Photo, and Audio Documents of St. Petersburg).")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("MOSCOW")])]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "width": "20%"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablet"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("RGALI")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablet"
  }, [_vm._v("Rossiiskii gosudarstvennyi arkhiv literatury i iskusstva (Russian State Archive of Literature and Art).")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("GARF")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_vm._v("Gosudarstvennyi arkhiv Rossiiskoi Federatsii (State Archive of the Russian Federation).")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_vm._v("RGAF")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_vm._v("Rossiiskii gosudarstvennyi arkhiv fonodokumentov (Russian State Archive of Audio Documents).")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SA FSB")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_vm._v("Tsentral’nyi arkhiv Federal’nyi sluzhby bezopasnosti Rossiiskoi Federatsii (Central Archive of the Federal Security Service ("), _c('span', {
    staticClass: "small"
  }, [_vm._v("FSB")]), _vm._v(") of the Russian Federation).")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("VILNIUS")])]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "width": "20%"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablet"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("LVIA")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablet"
  }, [_vm._v("Lietuvos valstybes istorijos archyvas (State Historical Archive of Lithuania).")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("LLMA")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_vm._v("Lietuvos literaturos ir meno archyvas (Lithuanian Archive of Literature and Art).")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("WASHINGTON, DC")])]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "width": "20%"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablet"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("JHC LOC")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tablet"
  }, [_vm._v("The Jascha Heifetz Collection, Library of Congress.")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("NEW YORK")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The New York Public Library.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Sources taken from the Russian collections are listed according to standard Russian archival terminology: f[ond] = a unified collection of archival materials; op[is’] = an inventory or list of files in a fond; d[elo] = a file, an item, or a unit in a fond, or a basic unit of classification in a fond; ed[initsa] khr[aneniia] = similar to a delo, a unit of archival storage comprising a single document or a collection of related documents, or a file; l[ist] = folder, folio, leaf, or sheet; s[tranitsa] = page; ob[orot] = verso, overpage, or overleaf of a sheet.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_xxi"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0xxi-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Vilnius, 1904. Adapted from "), _c('em', [_vm._v("Evreiskaia entsiklopediia")]), _vm._v(", vol. 5 (St. Petersburg: Brockhaus & Efron, 1908–1913), 572–573.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_xxii"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/fxxii-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('a', {
    attrs: {
      "id": "page_xxiii"
    }
  }), _vm._v("The Heifetz Family Tree. Jascha Heifetz’s branch of the tree is shown in full. The remaining branches are shown in proportion to their representation in the text of the book. Marriage indicated with a thick line.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_xxiv"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/fxxiv-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "captiona"
  }, [_vm._v("The location of the Heifetz family’s residences in St. Petersburg:")]), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("1. January to April 1910: 37 Ofitserskaya Street (now Decembrists’ Street)")]), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("2. From September 1910: 11/55 Bolshaya Masterskaya Street (now Lermontovsky Prospekt, 9/55)")]), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("3. September 1911: 40 Angliisky Prospekt")]), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("4. From October 1911: 20 Voznesensky Prospekt")]), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("5. From September 1912: 8/10 Masterskaya Street")]), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("6. From October 1913: 119 Yekaterininsky Canal (now Griboedov Canal)")]), _vm._v(" "), _c('p', {
    staticClass: "caption1"
  }, [_vm._v("7. January 1915 to July 1917: 115 Yekateringofsky Prospekt (now Rimsky-Korsakov Prospekt)")]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Adapted and expanded from a map by Martin Gilbert in Mikhail Beizer, "), _c('em', [_vm._v("The Jews of St. Petersburg: Excursions through a Noble Past")]), _vm._v(". Philadelphia: The Jewish Publication Society, 1989, xxix. "), _c('em', [_vm._v("Courtesy of Sir Martin Gilbert")]), _vm._v(".")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22912480","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/abbreviation.vue
// module id = 81
// module chunks = 0